<div class="container-fluid p-4 min-vh-100 d-flex align-items-center">
  <div class="card shadow-none p-4 border-0 w-100">
    <div class="row row-cols-1 row-cols-md-2 g-0 gy-5 gx-md-5 min-h-94vh align-items-stretch">
      <!-- Login Form Column -->
      <div class="col align-self-center">
        <img [src]="logo" alt="Vult Logo" height="50" class="d-block mx-auto mb-3" />

        <!-- Marks this as the platform admin portal, not an academy dashboard (PF-0150). -->
        <div class="text-center">
          <span class="admin-portal-badge">
            <i class="isax isax-shield-tick"></i>
            {{ 'LOGIN.ADMIN_PORTAL_BADGE' | translate }}
          </span>
        </div>

        <h2 class="text-center fw-bold mt-3 mb-4">{{ 'LOGIN.LOGIN_BUTTON' | translate }}</h2>

        <!-- Error Alert -->
        <div *ngIf="errorMessage"
          class="alert alert-danger py-2 px-3 fs-13px rounded-3 mb-3 d-flex align-items-center gap-2 mx-auto"
          style="max-width: 500px">
          <i class="bx bx-error-circle fs-5"></i>
          <span>{{ errorMessage }}</span>
        </div>

        <!-- Credentials Login Form -->
        <form *ngIf="!mfaRequired" nz-form (keypress.enter)="onSubmit()" class="custom_form mx-auto"
          style="max-width: 500px" [formGroup]="loginForm">
          <nz-form-item class="mb-3">
            <nz-form-control [nzErrorTip]="nzErrorTip">
              <nz-form-label [nzRequired]="loginForm | isRequired: 'userName'">
                {{ 'LOGIN.USERNAME_LABEL' | translate }}
              </nz-form-label>
              <input formControlName="userName" nz-input class="bg-transparent h-50px" nzSize="large" name="username"
                [placeholder]="'LOGIN.USERNAME_PLACEHOLDER' | translate" type="text" id="username" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item class="mb-1">
            <nz-form-control [nzErrorTip]="nzErrorTip">
              <nz-form-label [nzRequired]="loginForm | isRequired: 'password'">
                {{ 'LOGIN.PASSWORD_LABEL' | translate }}
              </nz-form-label>
              <app-password-input formControlName="password"
                [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"></app-password-input>
            </nz-form-control>
          </nz-form-item>

          <div class="col-12 mt-3">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <label nz-checkbox formControlName="rememberMe">
                  <small>{{ 'LOGIN.REMEMBER_ME' | translate }}</small>
                </label>
              </div>
            </div>
          </div>

          <button type="button" (click)="onSubmit()" [disabled]="loading"
            class="col-12 btn btn-primary-gradient admin-login-btn fw-medium h-50px mt-4 d-flex align-items-center justify-content-center gap-2">
            <span class="bx bx-loader bx-spin fs-5" *ngIf="loading"></span>
            <span>{{ loading ? ('COMMON.LOADING' | translate) : ('LOGIN.LOGIN_BUTTON' | translate) }}</span>
          </button>
        </form>

        <!-- Two-Factor Authentication Challenge Form -->
        <div *ngIf="mfaRequired" class="mx-auto" style="max-width: 500px">
          <div class="text-center mb-4">
            <div class="d-inline-flex p-3 rounded-circle bg-primary bg-opacity-10 text-primary mb-2">
              <i class="isax isax-shield-security fs-2 text-primary"></i>
            </div>
            <h4 class="fw-bold mb-1">{{ 'LOGIN.MFA_TITLE' | translate }}</h4>
            <p class="text-muted small mb-2">
              {{ (useRecoveryCode ? 'LOGIN.MFA_RECOVERY_SUBTITLE' : 'LOGIN.MFA_SUBTITLE') | translate }}
            </p>
            <span class="badge bg-light text-dark border px-2 py-1 fs-12px">
              <i class="bx bx-time-five me-1"></i>
              {{ 'LOGIN.MFA_EXPIRES_IN' | translate }}: <strong>{{ formattedCountdown }}</strong>
            </span>
          </div>

          <form nz-form (keypress.enter)="onMfaSubmit()" [formGroup]="mfaForm">
            <!-- 6-digit TOTP input -->
            <nz-form-item *ngIf="!useRecoveryCode" class="mb-3">
              <nz-form-control>
                <nz-form-label class="d-block text-center">{{ 'LOGIN.MFA_CODE_LABEL' | translate }}</nz-form-label>
                <input nz-input formControlName="code" type="text" maxlength="6"
                  class="form-control text-center fs-3 fw-bold tracking-wider h-50px" placeholder="000000"
                  autocomplete="one-time-code" />
              </nz-form-control>
            </nz-form-item>

            <!-- Recovery code input -->
            <nz-form-item *ngIf="useRecoveryCode" class="mb-3">
              <nz-form-control>
                <nz-form-label class="d-block text-center">{{ 'LOGIN.MFA_RECOVERY_CODE_LABEL' | translate
                  }}</nz-form-label>
                <input nz-input formControlName="recoveryCode" type="text"
                  class="form-control text-center fs-4 fw-medium text-uppercase h-50px" placeholder="XXXX-XXXX" />
              </nz-form-control>
            </nz-form-item>

            <!-- Toggle Recovery / App Code -->
            <div class="text-center mb-4">
              <a class="text-primary pointer small text-decoration-none" (click)="toggleRecoveryCode()">
                {{ (useRecoveryCode ? 'LOGIN.MFA_USE_APP_CODE' : 'LOGIN.MFA_USE_RECOVERY_CODE') | translate }}
              </a>
            </div>

            <!-- Verify Submit Button -->
            <button type="button" (click)="onMfaSubmit()" [disabled]="loading || countdownSeconds <= 0"
              class="col-12 btn btn-primary-gradient fw-medium h-50px d-flex align-items-center justify-content-center gap-2 mb-2">
              <span class="bx bx-loader bx-spin fs-5" *ngIf="loading"></span>
              <span>{{ loading ? ('COMMON.LOADING' | translate) : ('LOGIN.MFA_VERIFY_BUTTON' | translate) }}</span>
            </button>

            <!-- Back to Login -->
            <button type="button" (click)="cancelMfa()"
              class="col-12 btn btn-light border h-45px text-muted fw-medium d-flex align-items-center justify-content-center gap-2">
              <i class="bx bx-arrow-back"></i>
              <span>{{ 'LOGIN.MFA_BACK_TO_LOGIN' | translate }}</span>
            </button>
          </form>
        </div>

        <ng-template #nzErrorTip let-control>
          <app-nz-control-error-temp [control]="control"></app-nz-control-error-temp>
        </ng-template>
      </div>

      <!-- Branded Welcome Column: dark admin tone with the Vult green as accent (PF-0150) -->
      <div class="col d-none d-md-block">
        <div class="card shadow-none border-0 mo-gradient admin-panel h-100 rounded-4">
          <div class="overlay"></div>
          <div class="card-body h-100 d-flex flex-column align-items-start p-4 p-md-5">
            <img [src]="logoLight" height="50" alt="Vult Logo" />

            <h2 class="text-white fw-bold my-3">
              {{ 'LOGIN.SUPER_ADMIN_WELCOME_TITLE' | translate }}
            </h2>

            <p class="text-white opacity-75 fs-1_6rem">
              {{ 'LOGIN.SUPER_ADMIN_WELCOME_DESC' | translate }}
            </p>

            <!-- Feature Highlights Carousel (One card at a time with indicator dots) -->
            <div class="mt-auto w-100">
              <owl-carousel-o [options]="carouselOptions">
                <ng-template carouselSlide *ngFor="let feat of features">
                  <div class="package-card">
                    <div class="d-flex align-items-center gap-2 mb-2">
                      <i [class]="feat.icon + ' text-white fs-4'"></i>
                      <h4 class="text-white fw-bold mb-0">
                        {{ feat.title | translate }}
                      </h4>
                    </div>
                    <p class="text-white opacity-75 mb-0">
                      {{ feat.desc | translate }}
                    </p>
                  </div>
                </ng-template>
              </owl-carousel-o>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>